/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AlertType,
    AlertTypeFromJSON,
    AlertTypeFromJSONTyped,
    AlertTypeToJSON,
    Definition,
    DefinitionFromJSON,
    DefinitionFromJSONTyped,
    DefinitionToJSON,
    DocumentInfo,
    DocumentInfoFromJSON,
    DocumentInfoFromJSONTyped,
    DocumentInfoToJSON,
    DocumentStatus,
    DocumentStatusFromJSON,
    DocumentStatusFromJSONTyped,
    DocumentStatusToJSON,
    Interrogatory,
    InterrogatoryFromJSON,
    InterrogatoryFromJSONTyped,
    InterrogatoryToJSON,
    ParentRelationship,
    ParentRelationshipFromJSON,
    ParentRelationshipFromJSONTyped,
    ParentRelationshipToJSON,
    Source,
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentDetail
 */
export interface DocumentDetail {
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    uploadedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    location?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentDetail
     */
    uploadDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof DocumentDetail
     */
    fileSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    parentDocumentId?: string | null;
    /**
     * 
     * @type {ParentRelationship}
     * @memberof DocumentDetail
     */
    parentRelationship?: ParentRelationship;
    /**
     * 
     * @type {Source}
     * @memberof DocumentDetail
     */
    source: Source;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    caseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    clientId?: string | null;
    /**
     * 
     * @type {DocumentStatus}
     * @memberof DocumentDetail
     */
    status: DocumentStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDetail
     */
    isArchived: boolean;
    /**
     * 
     * @type {DocumentInfo}
     * @memberof DocumentDetail
     */
    info?: DocumentInfo;
    /**
     * 
     * @type {Date}
     * @memberof DocumentDetail
     */
    lastWordDownloadDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDetail
     */
    caseIdConfirmed?: boolean;
    /**
     * 
     * @type {AlertType}
     * @memberof DocumentDetail
     */
    alert?: AlertType;
    /**
     * 
     * @type {Array<Definition>}
     * @memberof DocumentDetail
     */
    definitions?: Array<Definition> | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDetail
     */
    interrogatoryNotificationCount?: number | null;
    /**
     * 
     * @type {Array<Interrogatory>}
     * @memberof DocumentDetail
     */
    interrogatories: Array<Interrogatory>;
}

export function DocumentDetailFromJSON(json: any): DocumentDetail {
    return DocumentDetailFromJSONTyped(json, false);
}

export function DocumentDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'uploadedBy': !exists(json, 'uploadedBy') ? undefined : json['uploadedBy'],
        'name': json['name'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (new Date(json['uploadDate'])),
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
        'parentDocumentId': !exists(json, 'parentDocumentId') ? undefined : json['parentDocumentId'],
        'parentRelationship': !exists(json, 'parentRelationship') ? undefined : ParentRelationshipFromJSON(json['parentRelationship']),
        'source': SourceFromJSON(json['source']),
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'status': DocumentStatusFromJSON(json['status']),
        'isArchived': json['isArchived'],
        'info': !exists(json, 'info') ? undefined : DocumentInfoFromJSON(json['info']),
        'lastWordDownloadDate': !exists(json, 'lastWordDownloadDate') ? undefined : (json['lastWordDownloadDate'] === null ? null : new Date(json['lastWordDownloadDate'])),
        'caseIdConfirmed': !exists(json, 'caseIdConfirmed') ? undefined : json['caseIdConfirmed'],
        'alert': !exists(json, 'alert') ? undefined : AlertTypeFromJSON(json['alert']),
        'definitions': !exists(json, 'definitions') ? undefined : (json['definitions'] === null ? null : (json['definitions'] as Array<any>).map(DefinitionFromJSON)),
        'interrogatoryNotificationCount': !exists(json, 'interrogatoryNotificationCount') ? undefined : json['interrogatoryNotificationCount'],
        'interrogatories': ((json['interrogatories'] as Array<any>).map(InterrogatoryFromJSON)),
    };
}

export function DocumentDetailToJSON(value?: DocumentDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'uploadedBy': value.uploadedBy,
        'name': value.name,
        'location': value.location,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate.toISOString()),
        'fileSize': value.fileSize,
        'parentDocumentId': value.parentDocumentId,
        'parentRelationship': ParentRelationshipToJSON(value.parentRelationship),
        'source': SourceToJSON(value.source),
        'caseId': value.caseId,
        'clientId': value.clientId,
        'status': DocumentStatusToJSON(value.status),
        'isArchived': value.isArchived,
        'info': DocumentInfoToJSON(value.info),
        'lastWordDownloadDate': value.lastWordDownloadDate === undefined ? undefined : (value.lastWordDownloadDate === null ? null : value.lastWordDownloadDate.toISOString()),
        'caseIdConfirmed': value.caseIdConfirmed,
        'alert': AlertTypeToJSON(value.alert),
        'definitions': value.definitions === undefined ? undefined : (value.definitions === null ? null : (value.definitions as Array<any>).map(DefinitionToJSON)),
        'interrogatoryNotificationCount': value.interrogatoryNotificationCount,
        'interrogatories': ((value.interrogatories as Array<any>).map(InterrogatoryToJSON)),
    };
}


